import { useEffect, useState } from "react";
import Modal from "react-modal";
import api from "../../services/api";
import ReactLoading from "react-loading";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";

type ModalDeliveryProps = {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
};

type HourType = {
	id: number;
	time: string;
};

type HourResponseType = {
	id: number;
	weekday: number;
	timeStart: string;
	timeStart2: string;
	timeEnd: string;
	timeEnd2: string;
};

export function ModalInfo({ isOpen, setIsOpen }: ModalDeliveryProps) {
	const [hours, setHours] = useState<Array<HourType>>([]);
	const [loadHours, setLoadHours] = useState(false);

	const { getToken } = usePluginspace();

	useEffect(() => {
		getHours();
	}, []);

	async function getHours() {
		setLoadHours(true);
		await api
			.get(`/api/location-operation`, {
				headers: {
					Authorization: `Bearer ${await getToken()}`,
				},
			})
			.then(async (response) => {
				const newHours: Array<HourType> = [];
				response.data.data.map((hour: HourResponseType) => {
					let weekday = "";
					switch (hour.weekday) {
						case 0:
							weekday = "Domingo";
							break;
						case 1:
							weekday = "Segunda";
							break;
						case 2:
							weekday = "Terça";
							break;
						case 3:
							weekday = "Quarta";
							break;
						case 4:
							weekday = "Quinta";
							break;
						case 5:
							weekday = "Sexta";
							break;
						case 6:
							weekday = "Sábado";
							break;
					}
					if (weekday != "") {
						if (
							hour.timeStart != "00:00:00" ||
							hour.timeEnd != "00:00:00" ||
							hour.timeStart2 != "00:00:00" ||
							hour.timeEnd2 != "00:00:00"
						) {
							if (hour.timeStart2 != hour.timeEnd2) {
								newHours.push({
									id: hour.id,
									time: `${weekday} das ${hour.timeStart.substring(
										0,
										5
									)} até as ${hour.timeEnd.substring(
										0,
										5
									)} e das ${hour.timeStart2.substring(
										0,
										5
									)} até ${hour.timeEnd2.substring(0, 5)}`,
								});
							} else {
								newHours.push({
									id: hour.id,
									time: `${weekday} das ${hour.timeStart.substring(
										0,
										5
									)} até as ${hour.timeEnd.substring(0, 5)}`,
								});
							}
						}
					}
				});
				setHours(newHours);
				setLoadHours(false);
			})
			.catch((err) => {
				setLoadHours(false);
				console.log(err);
			});
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={() => setIsOpen(false)}
			className="modal-infos"
			contentLabel="Endereço para entrega"
			overlayClassName="overlay-modal"
			ariaHideApp={false}
		>
			<div className="modal-infos-content">
				<div className="modal-infos-body">
					<div className="title">
						<svg
							onClick={() => setIsOpen(false)}
							width="17"
							height="17"
							viewBox="0 0 17 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
								fill="#636363"
							/>
						</svg>
					</div>
					<div className="description">
						<p>
							Escolha seus Favoritos e Compre Online. Conheça
							Todos os Produtos da Empresa Disponíveis na Loja
							Online
						</p>
					</div>
					<div className="hours">
						<p>Horários de funcionamento:</p>
						{loadHours ? (
							<ReactLoading
								type="spinningBubbles"
								color="#636363"
								height={40}
								width={40}
							/>
						) : (
							hours.map((hour) => (
								<div className="hour" key={hour.id}>
									<p>{hour.time}</p>
								</div>
							))
						)}
					</div>
				</div>
			</div>
		</Modal>
	);
}
